import { render, staticRenderFns } from "./CardsDeTotaisPorGrau.vue?vue&type=template&id=0affdf0e"
import script from "./CardsDeTotaisPorGrau.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardsDeTotaisPorGrau.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports